import {AttributeDescriptor, BaseModel, BaseModelDescriptor} from "./BaseModel";
import {User} from "./User";
import {ValidationTypes} from "../core/Validator";
import {FormatTypes} from "../core/Formater";

export class Notification extends BaseModel {

	id: string
    title: string
    description: string
	seen: boolean
	action: string
	userId: User
	data: any
	createdAt: Date
}

export class NotificationDescriptor extends BaseModelDescriptor{
	static id: AttributeDescriptor = {validation: []}
	static title: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static description: AttributeDescriptor = {validation: []}
	static createdAt: AttributeDescriptor = {validation: [], format: FormatTypes.DATETIME}
}
